import {gql} from '@apollo/client';
import {pwaClient} from './graphql_clients';
import {VehicleQuery} from '../gql/pwa/graphql';
import {pwaRequestHeaders} from '../support/network.ts';

const VEHICLE_FRAGMENT = gql`
    fragment VehicleFragment on Vehicle {
        id
        brand
        model
        identifiers {
            type
            value
            __typename
        }
        buildyear
        lease
        mileage
        tires
        color
        fuel_type
        inspection_expiration_date
        images {
            type
            url
            __typename
        }
        __typename
    }
`;

const GET_VEHICLE_DATA_QUERY = gql`
    query vehicle($license_plate: String) {
        vehicle(identifier: $license_plate) {
            ...VehicleFragment
            __typename
        }
    }
    ${VEHICLE_FRAGMENT}
`;

export class VehicleData {
    static async getVehicleData(license_plate: string) {
        return await pwaClient.query<VehicleQuery>({
            query: GET_VEHICLE_DATA_QUERY,
            variables: {
                license_plate: license_plate,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
    }
}
